/** Общая загрузка Digiseller API — один раз на сессию, можно вызвать заранее. */

export const DEFAULT_DIGISELLER_SELLER = '1054250'

const CSS_ID = 'digiseller-css'
const JS_ID = 'digiseller-js'

type DigisellerWin = Window & {
  digiseller?: unknown
  Digiseller?: { initBuy?: (el: HTMLElement) => void; init?: () => void; render?: () => void }
  digiseller_init?: () => void
}

let scriptReady: Promise<void> | null = null
let cssSeller: string | null = null

function sellerScriptSrc(seller: string): string {
  return `https://digiseller.com/store2/digiseller-api.js.asp?seller_id=${encodeURIComponent(seller)}&lang=ru-RU`
}

function sellerCssHref(seller: string): string {
  return `https://shop.digiseller.ru/xml/shop_css.asp?seller_id=${encodeURIComponent(seller)}`
}

function ensureCss(seller: string): void {
  if (cssSeller === seller && document.getElementById(CSS_ID)) return
  const existing = document.getElementById(CSS_ID)
  if (existing) {
    existing.remove()
  }
  const link = document.createElement('link')
  link.id = CSS_ID
  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = sellerCssHref(seller)
  document.head.appendChild(link)
  cssSeller = seller
}

function waitForApi(deadlineMs: number): Promise<void> {
  return new Promise((resolve) => {
    const deadline = Date.now() + deadlineMs
    const tick = () => {
      const w = window as DigisellerWin
      if (w.digiseller || w.Digiseller || w.digiseller_init) {
        resolve()
        return
      }
      if (Date.now() > deadline) {
        resolve()
        return
      }
      window.setTimeout(tick, 30)
    }
    tick()
  })
}

/** Подгрузить CSS + JS Digiseller. Безопасно вызывать многократно. */
export function preloadDigiseller(seller: string = DEFAULT_DIGISELLER_SELLER): Promise<void> {
  if (scriptReady && cssSeller === seller) return scriptReady

  scriptReady = new Promise((resolve) => {
    ensureCss(seller)
    const w = window as DigisellerWin
    if (document.getElementById(JS_ID) && (w.digiseller || w.Digiseller || w.digiseller_init)) {
      resolve()
      return
    }

    const existing = document.getElementById(JS_ID) as HTMLScriptElement | null
    if (existing) {
      void waitForApi(8000).then(resolve)
      return
    }

    const script = document.createElement('script')
    script.id = JS_ID
    script.async = true
    script.src = sellerScriptSrc(seller)
    script.onload = () => void waitForApi(8000).then(resolve)
    script.onerror = () => resolve()
    document.head.appendChild(script)
  })

  return scriptReady
}

export function initDigisellerBuy(standalone: HTMLElement): void {
  const w = window as DigisellerWin
  try {
    if (w.Digiseller?.initBuy) {
      w.Digiseller.initBuy(standalone)
      return
    }
    w.Digiseller?.init?.()
    w.Digiseller?.render?.()
    w.digiseller_init?.()
  } catch {
    /* no-op */
  }
}
